<template>
  <div class="page">
    <div class="router">
      <div @click="$router.go(-1)" class="back">
        <a-icon type="left"></a-icon>
        <div class="name">草稿箱 | 返回</div>
      </div>
      <div class="extra">
        {{ total }}
      </div>
    </div>
    <div infinite-scroll-throttle-delay="200"
              class="scroll-box"
              v-infinite-scroll="loadMore"
              :infinite-scroll-disabled="loading"
              infinite-scroll-distance="10">
      <observe-list></observe-list>
    </div>
  </div>
</template>

<script>
import observeList from '../../components/observe-list.vue';
export default {
  data() {
    return {
      showPlate: false,
    };
  },
  props:{
    loading:{
      type:Boolean,
      default:false
    }
  },
  components: {
    observeList
  },
  methods: {
    loadMore() {
      this.$emit('load')
    }
  },
};
</script>

<style lang="scss" scoped>

.page {
  height: 100%;
  max-width: 900px;
  margin: 0 auto;
  .router {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    flex-direction: row;
    padding: 0 0px;
    color: #999;
    .back {
      display: flex;
      align-items: center;
      cursor: pointer;
      flex-direction: row;
      .name {
        margin-left: 5px;
        color: #999;
      }
    }
  }

  .srcoll-box {
    height: calc(100% - 75px);
    overflow-y: auto;
    padding: 15px 20px;
    background: #fff;
    border-radius: 5px;
    .title {
      font-size: 18px;
      font-weight: bold;
      color: #333;
      margin-bottom: 20px;
    }
  }
}
.drawer-content {
  .head {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #eee;
    padding: 15px;
    .title {
      flex: 1;
      text-align: left;
      margin-left: 2px;
      font-size: 16px;
      margin-bottom: 0;
      font-family: "微软雅黑";
      font-weight: bold;
      //字体平滑
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }
  }

  .body {
    padding: 20px;
    .plate {
      margin-top: 20px;
      .item {
        font-size: 12px;
        width: 100px;
        height: 120px;
        border-radius: 5px;
        padding: 10px;
        margin-right: 10px;
        color: #777;
        position: relative;
        box-shadow: 1px 2px 3px 2px rgba($color: #0e6dc5, $alpha: 0.2);
        &::after {
          content: "";
          position: absolute;
          left: 10px;
          top: 50px;
          height: 5px;
          border-radius: 5px;
          width: 40px;
          background: #90bce6;
        }

        &::before {
          content: "";
          position: absolute;
          left: 10px;
          top: 60px;
          height: 5px;
          border-radius: 5px;
          width: 55px;
          background: #90bce6;
        }
      }
    }
  }
}
</style>
